export const getAttackPattern = {
  pathname: ({ type }) => `/api/v4/${type}/attack-pattern`,
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: ({ ids }) => ({ ids }),
}
